var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgSurvey(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 26,
    height: 25,
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M25.833 23.083a.917.917 0 0 1-.916.917H1.082a.917.917 0 0 1-.916-.917V2.917a.917.917 0 1 1 1.833 0v19.25h1.833V9.409a.917.917 0 0 1 .917-.916H7.5a.917.917 0 0 1 .916.916v12.758h1.834v-7.334a.917.917 0 0 1 .916-.916h2.75a.916.916 0 0 1 .917.916v7.334h1.833V6.583a.917.917 0 0 1 .917-.916h2.75a.917.917 0 0 1 .917.916v15.584h3.666a.916.916 0 0 1 .917.916z",
    fill: "#FFE14B"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSurvey);
export default __webpack_public_path__ + "static/media/survey.9456dd7d213341525a0363dd8f11c7bb.svg";
export { ForwardRef as ReactComponent };